// extracted by mini-css-extract-plugin
export default {"container":"MessageInfo_container__X2FVN","container_error":"MessageInfo_container_error__BNImw"};